import { MailingCommentSchema } from './mailing-comment.schema';

/**
 * Schema for a mailing comment reply, extending the base MailingCommentSchema.
 *
 * @remarks
 * This schema represents a reply to a mailing comment and can optionally include
 * an array of further replies, allowing for nested comment threads.
 *
 * @see MailingCommentSchema
 */
export const MailingCommentReplySchema = MailingCommentSchema.extend({
  replies: MailingCommentSchema.array().optional(),
});
